<div class="tax-date-container">
    <div *ngIf="sstReturnStatus === true">
        "The SST Return for {{ taxDate | date: dateFormatService.currentDateFormatValue }} has already been
        submitted. You cannot create or modify SST-related transactions for this period."
    </div>
    <div *ngIf="sstReturnStatus === false">

        "A Draft SST Return exists for {{ taxDate | date: dateFormatService.currentDateFormatValue }}. You
        cannot
        save a transaction with this Tax Date for this period. Please either set a new valid Tax Date within an open
        taxable period, or delete the Draft SST Return to proceed."
    </div>
    <br />
    <nz-form-item>
        <nz-form-control [nzErrorTip]="errorTip">
            <nz-form-label nzFor="taxDate" nzRequired>Tax Date</nz-form-label>
            <nz-date-picker [(ngModel)]="taxDate" [nzDisabledDate]="disabledDate" nzRequired [nzFormat]="dateFormatService.currentDateFormatValue">
            </nz-date-picker>
            <ng-template #errorTip>
                <span>Please select a valid tax date</span>
            </ng-template>
        </nz-form-control>
    </nz-form-item>

    <div class="note-text">
        (Note: Leave Tax Date empty if Tax Date is equal to Document Date)
    </div>
</div>